import React from 'react'
import Menu from './Menu'

function MenuItem({item,index,arrowopen,handleDrawerOpen}) {

  return <Menu item={item} key={index+item.name} index={index} arrowopen ={arrowopen} handleDrawerOpen={handleDrawerOpen}/>
}

export default MenuItem